import {
  GetCmsEsperaDocumentacion,
  PostCmsVerificarDocumentacion
} from "../../reducers/comisionesV2";
import * as actions from "../../actions/comisionesV2";
import { Preview } from "../../../types/IAction";
import { RequestArchivo } from "../../components/expedientsV2controls/types";
import { putCincelFirmas } from "../../actions/expedientes";

export interface ComisionesDeportivaAppGestionDispatcher {
  getCmsEsperaDocumentacion: (
    params?: any
  ) => Promise<Preview<GetCmsEsperaDocumentacion>>;
  putCmsInstructorPrincipal: (
    idInstancia: any,
    body: any
  ) => Promise<Preview<any>>;
  putCmsArchivo: (
    idInstancia: any,
    requestArchivo: RequestArchivo
  ) => Promise<Preview<any>>;
  putCincelFirmas: (idExpediente: any, idItem: any) => Promise<Preview<any>>;
  postCmsVerificarDocumentacion: (
    idInstancia: any
  ) => Promise<Preview<PostCmsVerificarDocumentacion>>;
}

export const comisionesDeportivaAppGestionDispatcher: (
  dispatch: (...args) => Promise<Preview<any>>
) => ComisionesDeportivaAppGestionDispatcher = dispatch => ({
  getCmsEsperaDocumentacion: (params?: any) => {
    return dispatch(actions.getCmsEsperaDocumentacion(params));
  },
  putCmsInstructorPrincipal: (idInstancia: any, body: any) => {
    return dispatch(actions.putCmsInstructorPrincipal(idInstancia, body));
  },
  putCmsArchivo: (
    idInstancia: any,
    requestArchivo: RequestArchivo
  ): Promise<Preview<any>> => {
    return dispatch(actions.putCmsArchivo(idInstancia, requestArchivo));
  },
  putCincelFirmas: (idExpediente: any, idItem: any): Promise<Preview<any>> => {
    return dispatch(putCincelFirmas(idExpediente, idItem));
  },
  postCmsVerificarDocumentacion: (
    idInstancia: any
  ): Promise<Preview<PostCmsVerificarDocumentacion>> => {
    return dispatch(actions.postCmsVerificarDocumentacion(idInstancia));
  }
});
